<template>
  <div>
    <v-app-bar
      app
      fixed
      dense
      flat
      :class="{ 'background-dark': isDark, 'background-light': !isDark }"
    >
      <v-row align="center" justify="start" class="mt-2">
        <v-btn icon @click="closeSelectedProduct">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </v-row>

      <!-- <template v-slot:img="{ props }">
        <v-img v-bind="props" aspect-ratio="2"></v-img>
      </template>-->
    </v-app-bar>
    <v-content fluid v-if="false">
      <v-layout class="overflow-y-auto" style="margin-bottom:60px">
        <v-container fluid fill-width class="overflow-y-auto">
          <v-subheader class="headline">{{ product.name }}</v-subheader>
          <blockquote class="blockquote">{{ product.description }}</blockquote>
          <v-spacer />
        </v-container>
      </v-layout>
      <v-layout align-end>
        <v-textarea
          v-model="comment"
          label="{traducir} How should it be prepared?"
          counter
          maxlength="120"
          full-width
          single-line
        />
      </v-layout>
    </v-content>

    <v-content :class="{ 'background-dark': isDark, 'background-light': !isDark }">
      <v-img v-if="product.banner" :src="product.banner" contain aspect-ratio="1.8" class="mb-4" />
      <div class="mx-2">
        <h2>{{ product.name }}</h2>
        <div class="body-1">{{ product.description }}</div>
        <div v-if="canOrder">
          <v-checkbox
            v-for="(option, index) in product.options"
            :key="index"
            v-model="options"
            :value="option"
            :label="
            option.name +
              ' (' +
              Number(option.addedPrice).toLocaleString('es-ES', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              }) +
              ' €)'
          "
          ></v-checkbox>
        </div>
        <div v-else>
          <v-list-item v-for="(option, index) in product.options" :key="index">
            {{option.name +
            ' (' +
            Number(option.addedPrice).toLocaleString('es-ES', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
            }) +
            ' €)'}}
          </v-list-item>
        </div>
        <v-textarea
          v-if="canOrder"
          v-model="comment"
          flat
          :label="$t('Add a comment...')"
          rows="1"
          auto-grow
          class="my-8"
        />
      </div>
    </v-content>

    <v-footer
      v-if="canOrder"
      app
      :color="isDark ? '#1e1e1e' : 'white'"
      class="d-flex justify-space-between pb-2"
    >
      <v-btn
        icon
        @click="
          if (amount > 1) {
            amount = amount - 1;
          }
        "
      >
        <v-icon>mdi-minus</v-icon>
      </v-btn>
      {{ amount }}
      <v-btn icon @click="amount = amount + 1">
        <v-icon>mdi-plus</v-icon>
      </v-btn>

      <v-btn
        outlined
        color="primary"
        @click="addProduct"
        class="body-1 font-weight-bold right"
        v-if="price > 0"
      >
        {{
        $t("Add {amount} for {price}", {
        price: localizedPrice(price),
        amount: amount
        })
        }}
      </v-btn>
    </v-footer>
  </div>
</template>

<script>
import { OrderProduct } from "@/model/order";

export default {
  name: "selectedProduct",
  props: ["product"],
  components: {},
  data() {
    return {
      amount: 1,
      comment: "",
      options: []
    };
  },

  methods: {
    localizedPrice(price) {
      // TODO actually localize
      return parseFloat(price).toFixed(2) + " €";
    },

    addProduct() {
      let orderProductMap = {
        ...this.product,
        comment: this.comment,
        status: "pending"
      };
      orderProductMap.options = this.options;

      let product = OrderProduct.fromMap(orderProductMap);
      for (let index = 0; index < this.amount; index++) {
        this.$emit("addProduct", product);
      }
      this.closeSelectedProduct();
    },
    closeSelectedProduct() {
      this.$emit("closeSelectedProduct");
    }
  },
  mounted() {
    const closeSelectedProduct = this.closeSelectedProduct;
    window.onpopstate = function() {
      closeSelectedProduct();
    };
    history.pushState({}, "");
    this.$vuetify.goTo(0, { duration: 0 });
  },
  computed: {
    menu: function() {
      return this.menufiltered;
    },
    price() {
      let price = Number(this.product.price ? this.product.price : 0);
      if (this.options) {
        console.log(this.options);
        this.options.forEach(option => (price += Number(option.addedPrice)));
      }
      return price * this.amount;
    },

    isDark() {
      return window.matchMedia("(prefers-color-scheme: dark)").matches;
    },
    canOrder() {
      return this.$store.getters.canOrder;
    }
  }
};
</script>

<style scoped>
.background-dark {
  background-color: #1e1e1e !important;
}
.background-light {
  background-color: white !important;
}
</style>
